import { lazy } from 'react';

export const AuthForgotPasswordResetScreenLazy = lazy(async () => {
  const { AuthForgotPasswordResetScreen } = await import('./auth-forgot-password-reset.screen.tsx');
  return { default: AuthForgotPasswordResetScreen };
});
